export default __webpack_public_path__ + "static/media/esporte_educa.036e3b96.png";